import { Routes } from '@angular/router';
import { Shell } from './layout/shell/shell';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    { path: '', redirectTo: 'portal', pathMatch: 'full' },
    {
        path: 'portal',
        children: [
            {
                path: '',
                component: Shell,
                canActivate: [authGuard],
                children: [
                    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
                    { path: 'dashboard', loadComponent: () => import('./features/dashboard/dashboard').then(m => m.Dashboard) },
                    { path: 'deals', loadChildren: () => import('./features/deals/routes').then(m => m.default) },
                    { path: 'resources', loadComponent: () => import('./features/resources/resources').then(m => m.Resources) },
                ],
            },
            {
                path: '',
                loadComponent: () => import('./features/auth/wrapper/wrapper').then(m => m.Wrapper),
                loadChildren: () => import('./features/auth/routes').then(m => m.default),
            },
        ],
    },
    { path: '**', redirectTo: 'portal' },
];
